import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpExpressionNodeFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpListValueElementFactory } from "./ExpListValueElement";
// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";

/**
 * 
 * @export
 * @interface ExpExpressionNode
 */

export class ExpExpressionNodeFactory {}

/**
* @export
* @enum {string}
*/
_ExpExpressionNodeFactory = ExpExpressionNodeFactory;
_defineProperty(ExpExpressionNodeFactory, "FromJSON", function (json) {
  return _ExpExpressionNodeFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpExpressionNodeFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'label': json['label'],
    'description': json['description'],
    'nodeType': json['nodeType'],
    'operandName': json['operandName'],
    'categoryID': json['categoryID'],
    'valueTypeIDs': json['valueTypeIDs'] === null || json['valueTypeIDs'] === undefined ? json['valueTypeIDs'] : json['valueTypeIDs'],
    'multiple': json['multiple'],
    'value': json['value'],
    'listValue': json['listValue'] === null || json['listValue'] === undefined ? json['listValue'] : json['listValue'].map(ExpListValueElementFactory.FromJSON),
    'displayValue': json['displayValue'],
    'operatorID': json['operatorID'],
    'operandValues': json['operandValues'] === null || json['operandValues'] === undefined ? json['operandValues'] : json['operandValues'].map(_ExpExpressionNodeFactory.FromJSON),
    'editable': json['editable'],
    'disabled': json['disabled'],
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData']),
    'typeQualifier': json['typeQualifier'],
    'integrationConfiguration': json['integrationConfiguration'] === null || json['integrationConfiguration'] === undefined ? json['integrationConfiguration'] : json['integrationConfiguration'],
    'executionFlags': json['executionFlags'] === null || json['executionFlags'] === undefined ? json['executionFlags'] : json['executionFlags']
  };
});
_defineProperty(ExpExpressionNodeFactory, "ToJSON", function (value) {
  return _ExpExpressionNodeFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpExpressionNodeFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'label': value.label,
    'description': value.description,
    'nodeType': value.nodeType,
    'operandName': value.operandName,
    'categoryID': value.categoryID,
    'valueTypeIDs': value.valueTypeIDs,
    'multiple': value.multiple,
    'value': value.value,
    'listValue': value.listValue === undefined ? undefined : value.listValue.map(ExpListValueElementFactory.ToJSON),
    'displayValue': value.displayValue,
    'operatorID': value.operatorID,
    'operandValues': value.operandValues === undefined ? undefined : value.operandValues.map(_ExpExpressionNodeFactory.ToJSON),
    'editable': value.editable,
    'disabled': value.disabled,
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData),
    'typeQualifier': value.typeQualifier,
    'integrationConfiguration': value.integrationConfiguration,
    'executionFlags': value.executionFlags
  };
});
export let ExpExpressionNodeNodeTypeEnum = /*#__PURE__*/function (ExpExpressionNodeNodeTypeEnum) {
  ExpExpressionNodeNodeTypeEnum["ACTION_LIST"] = "ACTION_LIST";
  ExpExpressionNodeNodeTypeEnum["LITERAL"] = "LITERAL";
  ExpExpressionNodeNodeTypeEnum["OPERATOR"] = "OPERATOR";
  ExpExpressionNodeNodeTypeEnum["REFERENCE"] = "REFERENCE";
  return ExpExpressionNodeNodeTypeEnum;
}({});
//# sourceMappingURL=ExpExpressionNode.js.map
